import { withInstall } from "../utils";
import _ActionBarButton from "./ActionBarButton";
const ActionBarButton = withInstall(_ActionBarButton);
var stdin_default = ActionBarButton;
export {
  ActionBarButton,
  stdin_default as default
};
